import { api } from '../client';
import type { SearchResponse } from '../generated/schema';

export async function searchEntities(query: string): Promise<SearchResponse> {
  return api.get<SearchResponse>('api/console/search', { searchParams: { q: query } });
}
